import { StyleSheet } from 'aphrodite';
import bg from '../../../assets/focused-view-background.png';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';
import { white } from '../../../styles/colors';

// nameCircles with 50% opacity
const backgroundColor = 'rgba(211, 219, 222, .5)';

export const styleSheet = StyleSheet.create({
	activity: {},
	container: {
		boxSizing: 'border-box',
		display: 'flex',
		width: '100%',
		height: `calc(100% - 100px)`,
		paddingRight: SPACE[16],
		background: THEME.colors.background.light,
	},
	splitDetail: {
		borderLeft: '1px solid #ccc',
		flex: '1 0 0',
		overflowY: 'auto',
		width: '100%',
	},
	splitMaster: {
		flex: '0 0 392px',
		overflowY: 'auto',
		background: white,
	},
	navHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: `0 16px`,
		background: `url(${bg}) no-repeat`,
		backgroundSize: '100% auto',
		height: 100,
		alignItems: 'center',
	},
	navHeaderLeft: {
		display: `flex`,
		alignItems: `center`,
		width: 90,
		justifyContent: `flex-start`,
	},
	navHeaderRight: {
		display: `flex`,
		alignItems: `center`,
		width: 90,
		justifyContent: `flex-end`,
	},
	navIcon: {
		alignItems: 'center',
		backgroundColor,
		borderRadius: '100%',
		display: 'inline-flex',
		height: 60,
		justifyContent: 'center',
		overflow: 'hidden',
		userSelect: 'none',
		verticalAlign: 'middle',
		width: 60,
	},
	backIcon: {
		transform: 'rotate(90deg)',
	},
	nextIcon: {
		transform: 'rotate(-90deg)',
	},
	navHeaderCenter: {
		flexGrow: 1,
		color: 'white',
		fontSize: 20,
		textAlign: 'center',
	},
});
